<div class="cont" [ngClass]="{'tw-font-bold tw-text-sbBlue-600 tw-bg-sbBlue-100 dark:tw-bg-sbBlue-900 dark:tw-text-white hover:tw-bg-sbBlue-400 hover:tw-text-white' : selected, 'hover:tw-bg-sbGray-100 dark:hover:tw-bg-[#3c434c]': !selected}">
  <div class="tw-flex tw-justify-start tw-items-center tw-gap-4">
    <div *ngIf="!isSingleSelect" class="tw-flex tw-relative tw-justify-center tw-items-center tw-h-6 tw-w-6">
      <input type="checkbox" class="form-check-input tw-absolute" [checked]="selected">
      <span class="checkmark tw-bg-sbGray-100 dark:tw-bg-sbGray-800"></span>
    </div>
    <div class="tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-2">
      <sb-icon *ngIf="icon" [icon]="icon" class="cursor-help" style="display: inline-block;">
      </sb-icon>
      <sb-icon *ngIf="!label" [icon]="'details'" [ngbTooltip]="'lang.globals.idOrIdentifier'|translate"
               class="cursor-help"
               container="body">
      </sb-icon>
      <span [innerHtml]="label"></span>
      <sb-icon *ngIf="selected && isSingleSelect" icon="checked"></sb-icon>
    </div>
  </div>
</div>
